import css from './LaborAndToolsItemsTypesHeaderStep3.module.css';
import React, { useState } from 'react';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { FragmentInfoMobileDropdown } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/FragmentInfoMobileDropdown/FragmentInfoMobileDropdown';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import CircularArrowsIcon from '@shared/Icons/CircularArrowsIcon';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';

interface Props {
    title?: string;
    description?: string;
    itemTypes: ItemTypeEntity[];
    expanded?: boolean;
    toggleExpand: () => void;
    disabledButtons?: boolean;
}

export const LaborAndToolsItemsTypesHeaderStep3: React.FC<Props> = ({
    title,
    description,
    itemTypes,
    expanded,
    toggleExpand,
    disabledButtons,
}) => {
    const selectedItemsViewModel = new ItemsSelectionViewModel();
    const [isDesktop] = useMediaType();

    const [clearSelectionAnimation, setClearSelectionAnimation] =
        useState(false);

    const handleSelectAll = () => {
        selectedItemsViewModel.selectAllItemsFromItemTypes(itemTypes);
    };

    const handleClearSelection = () => {
        selectedItemsViewModel.removeAllSelectedItemsFromItemTypes(itemTypes);
        setClearSelectionAnimation(true);
        setTimeout(() => setClearSelectionAnimation(false), 300);
    };

    return isDesktop ? (
        <div className={css.info}>
            <div className={css.titleContainer}>
                <div className={css.title}>{title}</div>
                <div className={css.description}>{description}</div>
            </div>
            <div className={css.btns}>
                <BasicButton
                    onClick={handleSelectAll}
                    extraClassName={`${css.selectAllBtn}`}
                    disabled={disabledButtons}
                >
                    Select all
                </BasicButton>
                <BasicButton
                    onClick={handleClearSelection}
                    extraClassName={css.clearSelectionBtn}
                    disabled={disabledButtons}
                >
                    <>
                        <CircularArrowsIcon
                            height={18}
                            width={18}
                            fill="currentColor"
                            className={
                                clearSelectionAnimation
                                    ? `${css.clearSelectionBtnRotatedIcon}`
                                    : `${css.clearSelectionBtnIcon}`
                            }
                        />
                        Clear fragment
                    </>
                </BasicButton>
            </div>
        </div>
    ) : (
        <>
            <FragmentInfoMobileDropdown
                isLaborAndTools={true}
                isExpanded={expanded}
                toggleExpand={toggleExpand}
                fragmentTitle={title}
                description={description}
            />

            <div
                className={`${css.btnsMobile} ${expanded ? css.showBtnsMobile : ''}`}
            >
                <BasicButton
                    onClick={handleSelectAll}
                    extraClassName={`${css.selectAllBtn}`}
                    disabled={disabledButtons}
                >
                    Select all
                </BasicButton>
                <BasicButton
                    onClick={handleClearSelection}
                    extraClassName={css.clearSelectionBtn}
                    disabled={disabledButtons}
                >
                    <>
                        <CircularArrowsIcon
                            height={18}
                            width={18}
                            className={
                                clearSelectionAnimation
                                    ? `${css.clearSelectionBtnRotatedIcon}`
                                    : `${css.clearSelectionBtnIcon}`
                            }
                            fill="currentColor"
                        />
                        Clear fragment
                    </>
                </BasicButton>
            </div>
        </>
    );
};
